import * as React from "react";
import { css, Global } from "@emotion/react";
import f from "@/module/Utils/emotion";
import v from "@/module/Utils/variable";
import resetCss from "@itkyk/emotion-reset-style";
import fontFaces from "@/module/Utils/font";
import Bg from "@/components/Organisms/Background";
import Util from "@/module/Utils/Util";
import { AnimatePresence } from "framer-motion";
import { globFunc } from "@/store/index";

// Images
import FloatGradation from "@/images/common/float_gradation-top.png";

//Component
import Header from "@/components/Organisms/Header";
import Landscape from "@/components/Organisms/Landscape";

interface LayoutProps {
  children: React.ReactElement;
  location: any;
}

const Layout: React.FC<LayoutProps> = ({ children, location }) => {
  //initialize
  const canvasRef = React.useRef(null);
  const [eyeElement, setEyeElement] = React.useState<React.ReactElement>(
    <div />
  );

  // Styles
  const globalStyle = css({
    html: {
      overscrollBehavior: "none",
    },
    body: {
      position: "relative",
      width: "100%",
      color: "#222222",
      boxSizing: "border-box",
      pointerEvents: "none",
      fontFamily: Util.isLang("ja")
        ? "TazuganeGothicStdN-Medium, Ginza"
        : "Ginza",
      fontWeight: 400,
      overscrollBehavior: "none",
      letterSpacing: Util.isLang("ja") ? "0.1em" : "0.07em",
      fontFeatureSettings: "'palt' 1",
      backgroundColor: "#C9161F",
      "&.is-loaded": {
        backgroundColor: "#fff",
      },
    },
    ".display-pc": {
      [f.sp()]: {
        display: "none!important",
      },
    },
    ".display-sp": {
      [f.pc()]: {
        display: "none!important",
      },
    },
    [`.disable-${process.env.GATSBY_LANG}`]: {
      display: "none!important",
    },
    "img, svg": {
      display: "block",
      width: "100%",
      verticalAlign: "top",
      lineHeight: 1.0,
      fontSize: 0,
      boxSizing: "border-box",
    },
    "button, a": {
      pointerEvents: "auto",
    },
  });

  const headerStyle = css({
    position: "fixed",
    width: "100%",
    top: 0,
    left: 0,
    zIndex: 3,
    touchAction: "none",
    [f.pc()]: {
      height: f.vw(99, v.pcWidth),
    },
  });

  const bgCanvas = css({
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    pointerEvents: "none",
    zIndex: -1,
    overflow: "visible",
  });

  const mainStyle = css({});

  // Logics
  const searchCanvasRef = async () => {
    if (canvasRef.current === null) {
      await Util.sleep(100);
      await searchCanvasRef();
    } else {
      return true;
    }
  };

  const setEyeReactElement = (ele: React.ReactElement) => {
    setEyeElement(ele);
  };

  const setBodyHeight = () => {
    document.getElementsByTagName(
      "body"
    )[0].style.height = `${window.innerHeight}px`;
  };

  globFunc.dispatch({ type: "addSetElement", func: setEyeReactElement });

  // LifeCycle
  React.useEffect(() => {
    setBodyHeight();
    window.addEventListener("resize", setBodyHeight);
    return () => {
      window.removeEventListener("resize", setBodyHeight);
    };
  }, []);

  return (
    <>
      <Global styles={[resetCss, fontFaces, globalStyle]} />
      <Landscape />
      <header css={headerStyle}>
        <Header />
      </header>
      <div css={bgCanvas}>
        <Bg ref={canvasRef} />
        <AnimatePresence exitBeforeEnter={true} initial={true}>
          {eyeElement}
        </AnimatePresence>
      </div>
      <main css={mainStyle}>{children}</main>
    </>
  );
};

export default Layout;
